import React from "react"
import {
  FaAlignLeft,
  FaAlignRight,
  FaAlignCenter,
  FaAlignJustify
} from "react-icons/fa"

import classes from "./EditorAlignment.module.scss"
import clsx from "clsx"

const EditorAlignment = (props) => {
  const { editor } = props

  return (
    <div className={classes["container"]}>
      <button
        onClick={() => editor.chain().focus().setTextAlign("right").run()}
        className={clsx(
          classes["button"],
          editor.isActive({ textAlign: "right" }) && classes["active"]
        )}
      >
        <FaAlignRight />
      </button>
      <button
        onClick={() => editor.chain().focus().setTextAlign("center").run()}
        className={clsx(
          classes["button"],
          editor.isActive({ textAlign: "center" }) && classes["active"]
        )}
      >
        <FaAlignCenter />
      </button>
      <button
        onClick={() => editor.chain().focus().setTextAlign("left").run()}
        className={clsx(
          classes["button"],
          editor.isActive({ textAlign: "left" }) && classes["active"]
        )}
      >
        <FaAlignLeft />
      </button>
      <button
        onClick={() => editor.chain().focus().setTextAlign("justify").run()}
        className={clsx(
          classes["button"],
          editor.isActive({ textAlign: "justify" }) && classes["active"]
        )}
      >
        <FaAlignJustify />
      </button>
    </div >
  )
}

export default EditorAlignment